export default __webpack_public_path__ + "static/media/Mark-5-Suit-10.c27f6bfc.jpg";